import { useContext, useEffect, useState } from 'react';
import './Laengenmass.scss';
import { getLaenge } from '../../utils/app-data';
import AppContext, { AppData } from '../../AppContext';
import { ValidationMessage, validateLaenge } from '../../utils/validations';
import Card from '../common/Card';
import { generateSlickSlider, registerGallery } from '../../utils/slick-slider';
import Artikelgallerie from './Artikelgallerie';

function Laengenmass() {
  const { appData, setDynamicAppData } = useContext(AppContext);

  const [laenge, setLaenge] = useState(getLaenge(appData));
  const [validations, setValidations] = useState([] as ValidationMessage[]);

  const checkValidity = (data: AppData): boolean => {
    const checkedValidations = validateLaenge(data);
    setValidations(checkedValidations);
    return !checkedValidations.find((v) => v.severity === 'error');
  };

  const inputColor = (error: boolean, warning: boolean) => {
    if (error) {
      return 'error';
    }
    if (warning) {
      return 'warning';
    }
    return 'valid';
  };

  const isLaengeError = () => !!validations.find((v) => v.severity === 'error'
    && v.kEigenschaft.includes(appData.static.kEigenschaftLaenge));
  const isLaengeWarning = () => !!validations.find((v) => v.severity === 'warning'
    && v.kEigenschaft.includes(appData.static.kEigenschaftLaenge));
  const inputColorLaenge = inputColor(isLaengeError(), isLaengeWarning());

  useEffect(() => {
    const newAppData = { ...appData };
    newAppData.dynamic.selectedVariationWerte[appData.static.kEigenschaftLaenge] = laenge;
    const valid = checkValidity(newAppData);

    setDynamicAppData((dynamicAppData) => {
      const newDynamicAppData = { ...dynamicAppData };
      newDynamicAppData.invalid = !valid;
      newDynamicAppData.selectedVariationWerte[appData.static.kEigenschaftLaenge] = laenge;
      return newDynamicAppData;
    });
  }, [laenge]); // eslint-disable-line react-hooks/exhaustive-deps

  const init = () => {
    generateSlickSlider();
    registerGallery();
  };
  useEffect(() => () => init());

  return (
    <div className="configurator__laengenmass">
      <Card>
        <Artikelgallerie />
        <div className="mt-3 d-flex flex-row justify-content-between align-items-center">
          <h3>Länge</h3>
        </div>
        <hr />
        <div className="mt-3 d-flex flex-column">
          <div className="inputs">
            <div className="input-group mb-2">
              <div className="input-group-prepend">
                <span className="input-group-text">Länge</span>
              </div>
              <input
                className={`${inputColorLaenge} form-control`}
                type="text"
                value={laenge}
                placeholder="Länge"
                pattern="^[0-9]*$"
                onChange={(e) => {
                  if (!Number.isNaN(Number(e.target.value))) {
                    setLaenge(Number(e.target.value));
                    init();
                  }
                }}
              />
              <div className="input-group-append">
                <span className="input-group-text">mm</span>
              </div>
            </div>
          </div>
          <div>
            {validations.map((v) => v.messageContent)}
          </div>
        </div>
      </Card>
    </div>
  );
}

export default Laengenmass;
